import vue from 'vue';
import { default as Component } from 'vue-class-component';
import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';
import Course from '../../../interfaces/Course';

@Component({
  template: require('./app-sidebar.html'),
  
  props: {}
})
export class AppSidebar extends vue {
  courseProvider = IocContainer.get<Course>(SERVICES.COURSE);

  sidebar = true;
  leftitems = [];

  get lessonsData() {
    return this.$store.state.lessons;
  }

  get userData() {
    return this.$store.state.user;
  }

  get adminStorageUrl() {
    return process.env.ADMIN_URL + 'storage/';
  }

  get courseTitle() {
    return this.$store.state.courseTitle;
  }

  get userProgress() {
    return this.$store.state.progress.filter((lesson) => {
      return !lesson.hasOwnProperty('reset');
    });
  }

  get expiration(){
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari){
      return (this.$store.state.user.expiration).slice(0, 10);
    }
    return new Date(this.$store.state.user.expiration).toLocaleDateString('en-US', {month : 'long',day : 'numeric',year : 'numeric'});
  }

  get lessonLastPassIndex() {
    if (this.userProgress.length > 0 && this.lessonsData.length > 0) {
      // const lessonLast = this.lessonsData.map((lesson) => {return lesson.id;}).indexOf(this.userProgress[this.userProgress.length - 1].id, this.userProgress.length - 2);
      this.leftitems = [];
      this.lessonsData.forEach(element => {
              if (!this.userProgress.find((lesson => {
                if (lesson.type === 'App\\Models\\Quiz' && lesson.resultPercentage == undefined){
                  return false;
                }
                  return lesson.id == element.id && lesson.type == element.type;
              }
              ))){
                this.leftitems.push(this.lessonsData.indexOf(element));
              }
            });
    }
    return this.leftitems[0] - 1;
  }

  get nextLesson() {
    if (this.lessonLastPassIndex > -1) {
      if (this.lessonLastPassIndex + 1 <= this.lessonsData.length) {
        return this.lessonsData[this.lessonLastPassIndex + 1];
      }
    } else {
      return this.lessonsData.find((lesson) => {
        return lesson.order === '000';
      });
    }
  }

  get sidebarClass() {
      return (this.sidebar) ? 'sidebar' : 'sidebar toggle';
  }

  sidebarToggle() {
    this.sidebar = !this.sidebar;
  }

  isLesson(lesson) {
    if (lesson) {
      return (lesson.type === 'App\\Models\\Lesson') ? true : false;
    }
  }

  isQuiz(lesson) {
    if (lesson) {
      return (lesson.type === 'App\\Models\\Quiz') ? true : false;
    }
  }

  get currentProgress(){

    let progressValue = Math.round((this.lessonsData.length - this.leftitems.length)/this.lessonsData.length*100);
    if (!this.lessonLastPassIndex){
      progressValue = 0;
    }
    if (this.finishedCourse){
      progressValue = 100;
    }
    return progressValue;
  }

  //current Score calculation

  get currentScore(){
    let correct = 0;
    let total = 0;

    let quizResults = this.userProgress.filter((lesson) => {
      return lesson.type === 'App\\Models\\Quiz' && lesson.resultPercentage != undefined;
    });
    if (quizResults.length > 0) {
      quizResults.forEach(quiz => {
        correct += parseInt(quiz.result[0]);
        total += parseInt(quiz.result[1]);
      });
      return Math.round(correct/total*100);
    }
    return 0;
  }
  
  get finalScore() {
//need to calculate only for last unit
    let total = 0;
    let blocksUnits = this.userProgress.filter((lesson) => {
      return lesson.type === 'App\\Models\\Quiz' && !lesson.hasOwnProperty('reset');
    });
    
    blocksUnits.forEach(quiz => {
      total += quiz.resultPercentage;
    });
    return total / blocksUnits.length;
  }

  // get finishedCourse() {
  //   if (this.userProgress.length > -1){
  //     if (this.finalScore > 65){
  //       if (this.userProgress[this.userProgress.length - 1].type == this.lessonsData[Object.keys(this.lessonsData)[Object.keys(this.lessonsData).length - 1]].type){
  //         return this.userProgress[this.userProgress.length - 1].id == this.lessonsData[Object.keys(this.lessonsData)[Object.keys(this.lessonsData).length - 1]].id;
  //       }
  //       return false;
  //     }
  //   else{
  //     return false;
  //     }
  //   }
  // }

  get finishedCourse() {
    if (this.userProgress.length > -1){
      const lastLesson = this.lessonsData[this.lessonsData.length - 1];
      if (this.finalScore > 65 && !this.lessonLastPassIndex && lastLesson){
        return this.userProgress.find((lesson) => {
          return lesson.id === lastLesson.id && lesson.type === lastLesson.type && lesson.result && !lesson.hasOwnProperty('reset');
        });
      }
      else{
        return false;
      }
    }
  }
}
